import { z } from 'zod';

export const MsegatConfigurationValueSchema = z.object({
  apiKey: z.string(),
  username: z.string(),
  sender: z.string(),
  enableOtp: z.boolean(),
});
